import React from 'react';
import PropTypes from 'prop-types';

const SectorField = (props) => {
  const { value, onChange } = props;

  const SectorFieldOptions = [
    { label: 'Public', value: 'Public' },
    { label: 'Private', value: 'Private' },
    { label: 'NGO', value: 'NGO' },
    { label: 'Other', value: 'Other' },
  ];

  return (
      <div className="pgn__form-select" id="id_sector">
        <label htmlFor="sector">Sector</label>
        <select
          id="sector"
          name="sector"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="" data-isdefault={true} selected={true}></option>
          {SectorFieldOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
  );
};

SectorField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SectorField;
